import gql from 'graphql-tag';
import { List } from 'immutable';

import GraphQLClient, { GraphQLOperationFailed } from '../../adapter/GraphQLClient';
import AmazonAdAccount from '../../entity/AmazonAdAccount';
import AmazonUploadedCreative from '../../entity/AmazonUploadedCreative';

export const handleAmazonError = (err: GraphQLOperationFailed) => {
  switch (err.type) {
    case 'upload_creative-unsupported_region':
      throw new UnSupportedRegionError();
    case 'upload_creative-invalid_params':
      throw new UploadCreativeInvalidParamsError();
    case 'upload_creative-token_not_found':
      throw new UploadCreativeTokenNotFoundError();
    case 'upload_creative-create_amazon_client_failed':
      throw new UploadCreativeCreateAmazonClientFailedError();
    case 'upload_creative-describe_media':
      throw new UploadCreativeDecribeMedia();
    case 'upload_creative-create_tmp_file_failed':
      throw new UploadCreativeTmpFileFailedError();
    case 'upload_creative-downloading_creative_failed':
      throw new UploadCreativeDonloadingCreativeFiledError();
    case 'upload_creative-copy_download_creative_failed':
      throw new UploadCreativeCopyDownloadCreativeFiledError();
    case 'upload_creative-creative_media_failed':
      throw new UploadCreativeMediaFailedError();
    case 'upload_creative-uploading_failed':
      throw new UploadCreativeUploadingFailedError();
    case 'upload_creative-complete_media_failed':
      throw new UploadCreativeCompleteMediaFailedError();
    case 'upload_creative-get_brands_failed':
      throw new UploadCreativeGetBrandsFailedError();
    case 'upload_creative-brands_not_found':
      throw new UploadCreativeBrandsNotFoundError();
    case 'upload_creative-find_productads_failed':
      throw new UploadCreativeProducctadsFailedError();
    case 'upload_creative-productads_not_found':
      throw new UploadCreativeProductadsNotFoundError();
    case 'upload_creative-uploaded_file_invalid':
      throw new UploadCreativeUploadedFileInvalidError();
    case 'upload_creative-create_draft_campaign_failed':
      throw new UploadCreativeCreateDraftCampaignFailedError();
    case 'upload_creative-register_data_failed':
      throw new UploadCreativeRegisterDataFailedError();
    case 'create_token-invalid_params':
      throw new CreateTokenINvalidParamsError();
    case 'create_token-get_access_token_failed':
      throw new CreateTokenGetAccessTokenFailedError();
    case 'create_token-get_amazon_user_info_failed':
      throw new CreateTokenGetAmazonUserInfoFailedError();
    case 'create_token-register_data_failed':
      throw new CreateTokenRegisterDataFailedError();
    case 'linkable_list-invalid_params':
      throw new LinkableListInvalidParamsError();
    case 'linkable_list-create_amazon_client_failed':
      throw new LinkableListCreateAmazonClientFailedError();
    case 'linkable_list-list_profiles_failed':
      throw new LinkableListProfilesFailedError();
    case 'linked_list-invalid_params':
      throw new LinkedListInvalidParamsError();
    case 'link_accounts-duplicate':
      throw new LinkAccountsDuplicateError();
    case 'link_accounts-invalid_params':
      throw new LinkAccountsInvalidParamsError();
    case 'link_accounts-register_token_adaccount_failed':
      throw new LinkAccountsRegisterTokenAdAccontFailedError();
    case 'link_accounts-token_not_found':
      throw new LinkAccountsTokenNotFoundError();
    case 'link_accounts-create_amazon_client_failed':
      throw new LinkAccountsCreateAmazonClientFailedError();
    case 'link_accounts-get_profile_api_failed':
      throw new LinkAccountsGetProfileApiFailedError();
    case 'link_accounts-register_adaccount_failed':
      throw new LinkAccountsRegisterAdAccountFailedError();
    case 'unlink_accounts-invalid_params':
      throw new UnlinkAccountsInvalidParamsError();
    case 'unlink_accounts-adaccount_not_found':
      throw new UnlinkAccountsAdAccountNotFoundError();
    case 'unlink_accounts-delete_adaccount_failed':
      throw new UnlinkAccountsDeleteAdAccountFailedError();
    case 'uploaded_creatives-invalid_params':
      throw new UploadedCreativesInvalidParamsError();
    default:
      throw err;
  }
};

export class UploadCreativeInvalidParamsError extends Error {
  public readonly name = 'UploadCreativeInvalidParamsError';
  public readonly message = 'message.amazon_upload_creative-invalid_params';
  constructor() {
    super();
  }
}
export class UploadCreativeTokenNotFoundError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-token_not_found';
  constructor() {
    super();
  }
}
export class UploadCreativeCreateAmazonClientFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-create_amazon_client_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeDecribeMedia extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-describe_media';
  constructor() {
    super();
  }
}
export class UploadCreativeTmpFileFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-create_tmp_file_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeDonloadingCreativeFiledError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-downloading_creative_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeCopyDownloadCreativeFiledError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-copy_download_creative_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeMediaFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-creative_media_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeUploadingFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-uploading_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeCompleteMediaFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-complete_media_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeGetBrandsFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-get_brands_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeBrandsNotFoundError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-brands_not_found';
  constructor() {
    super();
  }
}
export class UploadCreativeProducctadsFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-find_productads_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeProductadsNotFoundError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-productads_not_found';
  constructor() {
    super();
  }
}
export class UploadCreativeUploadedFileInvalidError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-uploaded_file_invalid';
  constructor() {
    super();
  }
}
export class UploadCreativeCreateDraftCampaignFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-create_draft_campaign_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeRegisterDataFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_upload_creative-register_data_failed';
  constructor() {
    super();
  }
}
export class CreateTokenINvalidParamsError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_create_token-invalid_params';
  constructor() {
    super();
  }
}
export class CreateTokenGetAccessTokenFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_create_token-get_access_token_failed';
  constructor() {
    super();
  }
}
export class CreateTokenGetAmazonUserInfoFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_create_token-get_amazon_user_info_failed';
  constructor() {
    super();
  }
}
export class CreateTokenRegisterDataFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_create_token-register_data_failed';
  constructor() {
    super();
  }
}
export class LinkableListInvalidParamsError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_linkable_list-invalid_params';
  constructor() {
    super();
  }
}
export class LinkableListCreateAmazonClientFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_linkable_list-create_amazon_client_failed';
  constructor() {
    super();
  }
}
export class LinkableListProfilesFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_linkable_list-list_profiles_failed';
  constructor() {
    super();
  }
}
export class LinkedListInvalidParamsError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_linked_list-invalid_params';
  constructor() {
    super();
  }
}
export class LinkAccountsDuplicateError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_link_accounts-duplicate';
  constructor() {
    super();
  }
}
export class LinkAccountsInvalidParamsError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_link_accounts-invalid_params';
  constructor() {
    super();
  }
}
export class LinkAccountsRegisterTokenAdAccontFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_link_accounts-register_token_adaccount_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsTokenNotFoundError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_link_accounts-token_not_found';
  constructor() {
    super();
  }
}
export class LinkAccountsCreateAmazonClientFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_link_accounts-create_amazon_client_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsGetProfileApiFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_link_accounts-get_profile_api_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsRegisterAdAccountFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_link_accounts-register_adaccount_failed';
  constructor() {
    super();
  }
}
export class UnlinkAccountsInvalidParamsError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_unlink_accounts-invalid_params';
  constructor() {
    super();
  }
}
export class UnlinkAccountsAdAccountNotFoundError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_unlink_accounts-adaccount_not_found';
  constructor() {
    super();
  }
}
export class UnlinkAccountsDeleteAdAccountFailedError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_unlink_accounts-delete_adaccount_failed';
  constructor() {
    super();
  }
}
export class UploadedCreativesInvalidParamsError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_uploaded_creatives-invalid_params';
  constructor() {
    super();
  }
}
export class UnSupportedRegionError extends Error {
  public readonly name = '';
  public readonly message = 'message.amazon_unsupported_region';
  constructor() {
    super();
  }
}

class AmazonAdWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  /**
   * @param organizationId
   * 連携済みAmazonAdAccountの配列が返却されます
   */
  public getAllIntegratedAdAccounts = async (organizationId: string): Promise<List<AmazonAdAccount>> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query integratedAmazonAdAccounts($organizationId: ID!) {
            integratedAmazonAdAccounts(organizationId: $organizationId) {
              id
              profileId
              name
              countryCode
            }
          }
        `,
        { organizationId },
      );
      const items = result.integratedAmazonAdAccounts as AmazonAdAccount[];
      return List(items);
    } catch (err) {
      handleAmazonError(err);
      throw err;
    }
  };

  /**
   * @param organizationId
   * @param tokenId
   * AmazonAdAccountのtokenIdを渡し、連携可能なアカウント一覧を返します
   */
  public getAllAccessibleAmazonAdAccounts = async (
    organizationId: string,
    tokenId: string,
  ): Promise<List<AmazonAdAccount>> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query accessibleAmazonAdAccounts($organizationId: ID!, $tokenId: ID!) {
            accessibleAmazonAdAccounts(organizationId: $organizationId, tokenId: $tokenId) {
              id
              profileId
              name
              countryCode
            }
          }
        `,
        { organizationId, tokenId },
      );
      const items = result.accessibleAmazonAdAccounts as AmazonAdAccount[];
      return List(items);
    } catch (err) {
      handleAmazonError(err);
      throw err;
    }
  };

  /**
   * @param authCode
   * @param organizationId
   * @param codeVerifier PKCEのcode_verifier
   * 連携するamazonAdAccountのauthCodeを渡し、tokenIdを受け取ります
   */
  public registerAmazonAccount = async (
    authCode: string,
    organizationId: string,
    codeVerifier: string,
  ): Promise<string> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation registerAmazonToken($authCode: String!, $organizationId: ID!, $codeVerifier: String!) {
            registerAmazonToken(authCode: $authCode, organizationId: $organizationId, codeVerifier: $codeVerifier)
          }
        `,
        { authCode, organizationId, codeVerifier },
      );
      const item = result.registerAmazonToken as string;
      return item;
    } catch (err) {
      handleAmazonError(err);
      throw err;
    }
  };

  /**
   * @param profileId
   * @param tokenId
   * @param organizationId
   * @param countryCode
   * AmazonAdAccount連携に必要なパラメータを渡し、連携を行います
   * 連携成功の場合true, 失敗の場合false
   */
  public integrateAdAccount = async (
    profileId: string,
    tokenId: string,
    organizationId: string,
    countryCode: string,
  ): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation integrateAmazonAdAccount(
            $organizationId: ID!
            $profileId: ID!
            $tokenId: ID!
            $countryCode: String!
          ) {
            integrateAmazonAdAccount(
              profileId: $profileId
              organizationId: $organizationId
              tokenId: $tokenId
              countryCode: $countryCode
            )
          }
        `,
        { profileId, organizationId, tokenId, countryCode },
      );
      return result.integrateAmazonAdAccount as boolean;
    } catch (err) {
      handleAmazonError(err);
      throw err;
    }
  };

  /**
   * @param profileId
   * @param organizationId
   * amazonAdAccountの連携を解除します
   */
  public revokeAdAccount = async (profileId: string, organizationId: string): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation revokeAmazonAdAccount($profileId: ID!, $organizationId: ID!) {
            revokeAmazonAdAccount(profileId: $profileId, organizationId: $organizationId)
          }
        `,
        { profileId, organizationId },
      );
      return result.revokeAmazonAdAccount;
    } catch (err) {
      handleAmazonError(err);
      throw err;
    }
  };

  /**
   * @param creativeId
   * @param organizationId
   * @param projectId
   * AmazonAdAccountに対して、クリエイティブ連携を行います
   */
  public sendCreativeToAmazon = async (
    creativeId: string,
    organizationId: string,
    projectId: string,
    profileId: string,
  ): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation sendCreativeToAmazon($projectId: ID!, $profileId: ID!, $creativeId: ID!, $organizationId: ID!) {
            sendCreativeToAmazon(
              projectId: $projectId
              profileId: $profileId
              organizationId: $organizationId
              creativeId: $creativeId
            ) {
              id
            }
          }
        `,
        { projectId, profileId, creativeId, organizationId },
      );
      return result.sendCreativeToAmazon;
    } catch (err) {
      handleAmazonError(err);
      throw err;
    }
  };

  /**
   * @param organizationId
   * @param creativeIds
   * アップロード済みクリエイティブを返します
   */
  public getUploadedAmazonCreatives = async (
    organizationId: string,
    creativeIds: string[],
  ): Promise<AmazonUploadedCreative[]> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query uploadedAmazonCreatives($organizationId: ID!, $creativeIds: [ID!]!) {
            uploadedAmazonCreatives(organizationId: $organizationId, creativeIds: $creativeIds) {
              creativeId
              mediaId
              uploadedAt
            }
          }
        `,
        { organizationId, creativeIds },
      );
      return result.uploadedAmazonCreatives;
    } catch (err) {
      handleAmazonError(err);
      throw err;
    }
  };
}

export default AmazonAdWebApi;
